<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container work_box">
        <h1 class="work">Доставка обедов в офисы и бизнес – ланчей</h1>
      </div>
    </div>
    <section class="section s-about_franchise">
      <div class="container">
        <div class="description_box">
          <div class="item">
            <p style="margin-top:2%;">Доставка еды в последнее время стала очень популярной услугой. Чтобы порадовать любимого мужа, детей, гостей и себя, женщинам уже не приходится по несколько часов стоять у плиты. Достаточно зайти на сайт понравившегося ресторана и выбрать любимые блюда! Также, большинство людей практически живут на работе. Они не могут себе позволить даже самого короткого обеда. Но есть решение. О нем мы узнаем  далее!</p>
            <h2 style="margin-top:2%;">Доставка ланчей и бизнес – ланчей</h2>
            <p>Как показывает статистика, большинство клиентов – это работающие люди. Они заказывают еду из ресторана, так как нет времени добежать до него, для «особенного» совещания, заседания и корпоративов. И почему многие фирмы предпочитают <router-link to="/lunch">заказывать бизнес – обеды</router-link>? Бизнес – ланч не подразумевает заказ одного или пары блюд. Это обед на целый коллектив и по выгодной цене, что, безусловно, радует, учитывая бюджет многих компаний. (Скидка может достигать до 30 %). Обед заказывают в определенное время. В большинстве ресторанов он подается с 12:00 до 15:00. Как раз классическое время для обеда.</p>
            <p>Ресторану выгодно, когда вы заказываете такой вид обеда, и чтобы не терять хватку, он всячески пытается разнообразить меню (сезонные блюда, специальные предложения на праздничный стол, «П.П» меню и другое).</p>
            <p style="margin-top:2%;">&nbsp;</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/eda-v-ofis.jpg" alt="Доставка обедов в офис"  width="640" /></center>
            <h2 style="margin-top:2%;">Доставка обедов в офис</h2>
            <p>Не придется больше таскать контейнеры с едой на работу, готовуюс вечера. Мы предоставим огромный каталог блюд, которые не смогут не порадовать любителей вкусно и сытно покушать! Вас удивит количество и разнообразие блюд, которые даже в самую несолнечную погоду подарят тёплые, солнечные и незабываемые ощущения. Вы будете приятно удивлены низкой ценой, качеством блюда и быстрым выполнением заказа.</p>
            <h2 style="margin-top:2%;">Доставка вкусных и недорогих обедов </h2>
            <p>Всем известна разница между дешевым и дорогим блюдом. Дорогое блюдо всегда лучшего качества, полезнее для нашего организма, так как приготовлено из свежих продуктов, а дешевое блюдо обещает желать лучшего. Если оно не ужасно маленьких размеров, то обязательно сделано из некачественных ингредиентов, что впоследствии плохо сказывается на нашем здоровье.  Мы предоставляем выход из положения. В нашей компании вы можете заказать и дорогое, и недорогое блюдо, а мы ручаемся, что каждое из них будет приготовлено профессионалами своего дела и из лучших продуктов!</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'inoffice'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/inoffice.vue